import { FC } from 'react'
import { PanelType } from '../BetLotto.types'
import { BetTabBar } from './BetTabBar'
import { useTranslation } from 'react-i18next'

export interface PanelTabsProps {
  activeTab: PanelType
  onTabChange: (tab: PanelType) => void
}

const tabs = [
  {
    key: 'betLottoPage.nav.choose_from_panel',
    value: 'panel',
  },
  {
    key: 'betLottoPage.nav.manual_bet',
    value: 'manual',
  },
]

export const PanelTabs: FC<PanelTabsProps> = ({ activeTab, onTabChange }) => {
  const { t } = useTranslation()
  const handleTabChange = (value: string) => {
    onTabChange(value as PanelType)
  }

  const tabsWithTranslations = tabs.map((tab) => ({
    ...tab,
    label: t(tab.key),
  }))

  return (
    <BetTabBar
      tabs={tabsWithTranslations}
      activeTab={activeTab}
      onChange={handleTabChange}
    />
  )
}
